import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ListForHistoryOrderItemsModule } from '@shared/core/components/lists/listsTypes/forHistoryOrderItems';
import { ListForTransactionItemsModule } from '@shared/core/components/lists/listsTypes/forTransactionItems';
import { OrderSummaryModule } from '../orderSummary';

import { OrderFullSummaryComponent } from './order-full-summary.shared.component';

@NgModule({
    declarations: [
        OrderFullSummaryComponent,
    ],
    imports: [
        CommonModule,
        OrderSummaryModule,
        ListForHistoryOrderItemsModule,
        ListForTransactionItemsModule,
    ],
    exports: [
        OrderFullSummaryComponent,
    ],
})
export class OrderFullSummaryModule { }
